import { defineStore } from 'pinia';
import { BasicJobTitle } from '../root/root-types';

export const useListStore = defineStore({
  id: 'listStore',

  state: () => ({
    jobTitles: [] as BasicJobTitle[],
    trafficAllowedJobTitles: [] as BasicJobTitle[],
  }),

  actions: {
    setJobTitles(value: BasicJobTitle[]): void {
      this.jobTitles = value;
    },
    setTrafficAllowedJobTitles(value: BasicJobTitle[]): void {
      this.trafficAllowedJobTitles = value;
    },
  },
});
